import React from "react";
import Flagship from "../../core/flagship";
import PropTypes from "prop-types";
import "../../styles/navBar.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/appActions";
import { throttle, empty } from "../../utils/helpers";
import {
  Image,
  Icon,
  Search,
  Dropdown,
  Loader,
  Header,
  Grid,
  Button,
  Popup,
} from "semantic-ui-react";
import { Link, IndexLink } from "react-router";

class NavBar extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      userMenuActive: false,
      searchResults: {},
      loadingSearch: false,
      isInstanceSwitcherOpen: false,
    };

    this.searchTimer = null;
    this.onSearchKeyUp = this.onSearchKeyUp.bind(this);
    this.getSearch = this.getSearch.bind(this);
    this.renderSearchResults = this.renderSearchResults.bind(this);
    this.handleInstanceSwitcherClose =
      this.handleInstanceSwitcherClose.bind(this);
    this.handleInstanceSwitcherOpen =
      this.handleInstanceSwitcherOpen.bind(this);
  }

  menuClick() {
    this.props.openMenu();
    this.setState({
      sidebarNavActive: !this.state.sidebarNavActive,
    });
  }

  onSearchKeyUp(e) {
    if (e.which === 13) {
      const newURL = "/search?search=" + this.props.search;
      Flagship.redirect(newURL);
    }

    this.props.actions.globalSearch(e.target.value);

    let getSearch = this.getSearch;
    this.searchTimer = throttle(
      function () {
        getSearch();
      },
      400,
      this.searchTimer
    );
  }

  getSearch() {
    if (!empty(this.props.search)) {
      let self = this;

      Flagship.get(
        "search/any/" + this.state.currentPage,
        {
          search: this.props.search,
          limit: 5,
          combine: true,
        },
        function (response) {
          if (response.data.success === true) {
            self.setState({
              searchResults: response.data.results,
              loadingSearch: false,
            });
          } else {
            Flagship.error(
              "Error getting search results from Flagship API server."
            );
          }
        },
        function (err) {
          Flagship.error(
            "Error getting search results from Flagship API server: " + err
          );
        }
      );
    } else {
      this.setState({
        searchResults: {},
        loadingSearch: false,
      });
    }
  }

  renderSearchResults(result) {
    let icon = "exclamation";
    switch (result.record_type) {
      case "client":
        icon = "briefcase";
        break;
      case "rfp":
        icon = "dollar";
        break;
      case "io":
        icon = "rocket";
        break;
    }

    if (
      this.props.userRole !== "ae" ||
      result.record_type === "io" ||
      result.record_type === "client"
    ) {
      return (
        <div key={"search-result-" + result.record_key}>
          <Link to={"/" + result.record_type + "/view/" + result.record_key}>
            <h3 className="blue-text">
              <Icon
                className="feed-icon"
                disabled
                size="large"
                color="grey"
                name={icon}
              />
              {result.record_type === "rfp" || result.record_type === "io"
                ? "#" + result.record_key
                : result.record_name}
            </h3>
            <h4 style={{ marginTop: "0px" }}>
              {result.record_type === "rfp" || result.record_type === "io"
                ? result.record_name
                : result.market}
            </h4>
          </Link>
        </div>
      );
    }
    return <span></span>;
  }

  changeInstance(which) {
    if (which !== this.props.instance) {
      this.props.actions.changeInstance(which);
      Flagship.setInstance(which);
      Flagship.notify("Switched to " + which + " Flagship.");
    }
    this.handleInstanceSwitcherClose();
  }

  handleInstanceSwitcherOpen() {
    this.setState({ isInstanceSwitcherOpen: true });
  }

  handleInstanceSwitcherClose() {
    this.setState({ isInstanceSwitcherOpen: false });
  }

  render() {
    const createMenuTrigger = (
      <div className="sub-menu-trigger create-menu-main-link">
        <Icon name="plus" />
        <span>Create New</span>
      </div>
    );

    let userMenuTrigger;

    if (this.props.userPhoto === null) {
      userMenuTrigger = (
        <div className="sub-menu-trigger user-menu-main-link">
          <Image src={Flagship.config.uploads + "someone.png"} avatar />
          <span>{this.props.username}</span>
        </div>
      );
    } else {
      userMenuTrigger = (
        <div className="sub-menu-trigger user-menu-main-link">
          <Image src={Flagship.config.uploads + this.props.userPhoto} avatar />
          <span>{this.props.username}</span>
        </div>
      );
    }

    const mainLogo = (
      <IndexLink to="/" id="flagship-main-logo">
        <Image
          src={Flagship.config.logo}
          className="flagship-main-logo"
          alt="Flagship Logo"
        />
        {this.props.makingRequest === true ? (
          <Loader active color="grey" className="fade-in main-request-loader" />
        ) : null}
      </IndexLink>
    );

    return (
      <div id="nav-bar" className="cf fade-in">
        <a
          id="flagship-menu"
          className={this.props.sidebarNavActive ? "open" : "closed"}
          onClick={this.menuClick.bind(this)}
        >
          <span></span>
          <span></span>
          <span></span>
        </a>

        {this.props.userInstance !== "Standard" &&
        this.props.userInstance !== "SHIFT" ? (
          <div className="dropdown-container">
            <Popup
              className="main-logo-dropdown"
              trigger={mainLogo}
              flowing
              hoverable
              position="bottom left"
              wide="very"
              hideOnScroll
              open={this.state.isInstanceSwitcherOpen}
              onClose={this.handleInstanceSwitcherClose}
              onOpen={this.handleInstanceSwitcherOpen}
            >
              <div style={{ minWidth: "320px" }}>
                <Header
                  className="choose-flagship-header"
                  as="h4"
                  textAlign="center"
                >
                  Choose Your Flagship...
                </Header>
                <Grid centered divided columns={2}>
                  <Grid.Column textAlign="center">
                    <Header as="h4">Standard Flagship</Header>
                    <Button
                      onClick={() => {
                        this.changeInstance("Standard");
                      }}
                    >
                      Choose
                    </Button>
                  </Grid.Column>
                  <Grid.Column textAlign="center">
                    <Header as="h4">SHIFT Flagship</Header>
                    <Button
                      onClick={() => {
                        this.changeInstance("SHIFT");
                      }}
                    >
                      Choose
                    </Button>
                  </Grid.Column>
                </Grid>
              </div>
            </Popup>
          </div>
        ) : (
          mainLogo
        )}

        <div id="nav-bar-right">
          <div id="flagship-main-search">
            <Search
              loading={this.state.loadingSearch}
              results={
                !empty(this.state.searchResults) ? this.state.searchResults : []
              }
              resultRenderer={this.renderSearchResults}
              minCharacters={2}
              placeholder="Search..."
              onKeyUp={this.onSearchKeyUp}
            />
          </div>
          {this.props.userRole !== "ae" && this.props.accessLevel === 2 ? (
            <div id="flagship-create-new" className="dropdown-container">
              <Dropdown trigger={createMenuTrigger} fluid icon={null}>
                <Dropdown.Menu>
                  <Dropdown.Item
                    as={Link}
                    to="/client/create"
                    icon="briefcase"
                    text=" Client"
                  />
                  {this.props.userMarket !== "Chicago" &&
                  this.props.instance !== "SHIFT" ? null : (
                    <Dropdown.Item
                      as={Link}
                      to="/rfp/create"
                      icon="dollar"
                      text=" RFP"
                    />
                  )}
                  <Dropdown.Item
                    as={Link}
                    to="/io/create"
                    icon="rocket"
                    text=" IO"
                  />
                </Dropdown.Menu>
              </Dropdown>
            </div>
          ) : null}

          <div id="flagship-user-menu" className="dropdown-container">
            <Dropdown trigger={userMenuTrigger} fluid icon={null}>
              <Dropdown.Menu>
                <Dropdown.Item
                  as={Link}
                  to={"/user/edit/" + this.props.userId}
                  icon="setting"
                  text="My Account"
                />
                <Dropdown.Item
                  as={Link}
                  to="/user/favorites/"
                  icon="favorite"
                  text=" Favorite Items"
                />
                <Dropdown.Item
                  as={Link}
                  to="/logout/"
                  icon="sign out"
                  text="Log Out"
                />
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    );
  }
}

NavBar.propTypes = {
  userPhoto: PropTypes.string,
  username: PropTypes.string,
  sidebarNavActive: PropTypes.bool,
  userId: PropTypes.number,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    isLoggedIn: state.main.isLoggedIn,
    username: state.main.username,
    userPhoto: state.main.userPhoto,
    userId: state.main.userId,
    userRole: state.main.userRole,
    accessLevel: state.main.accessLevel,
    userInstance: state.main.userInstance,
    userMarket: state.main.userMarket,
    sidebarNavActive: state.main.sidebarNavActive,
    errors: state.main.errors,
    notification: state.main.notification,
    makingRequest: state.main.makingRequest,
    instance: state.main.instance,
    search: state.main.search,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);



// WEBPACK FOOTER //
// ./src/components/ui/NavBar.js